
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Busrentalforcorporateevents() {



const cardData =
{
  keyword: 'Bus Rental For Corporate Events in Pune',
  heading: 'eTravo: Bus Rental for Corporate Events in Pune',
  headingDescription: 'Need to move your team or clients across Pune for an upcoming business event? eTravo offers well-maintained AC and luxury buses for all types of corporate events—from conferences and workshops to seminars, team outings, and guest transfers. Whether you need a 25-seater, 35-seater, or 50+ seater bus, we provide punctual, clean, and GPS-enabled vehicles with experienced drivers. Our services are designed to ensure stress-free group mobility, efficient coordination, and comfort for every corporate traveler in Pune.',

  top: 'Top Places in Pune for Corporate Events & Gatherings',
  topPlaces: [
    {
      title: 'JW Marriott Hotel Pune',
      description: 'A prestigious 5-star venue on Senapati Bapat Road, ideal for large-scale conferences, corporate launches, and executive retreats. eTravo’s luxury buses frequently transport corporate teams and guests to this centrally located business hub with hassle-free group coordination.'
    },
    {
      title: 'ICC Trade Towers',
      description: 'A landmark destination in Pune for conventions, expos, and high-level meetings. Our buses are often hired by companies to shuttle delegates, employees, and equipment directly to ICC with organized boarding points across the city.'
    },
    {
      title: 'The Westin Pune Koregaon Park',
      description: 'Known for hosting high-profile corporate events and business dinners, this hotel is a go-to venue for companies welcoming national and international clients. eTravo ensures seamless pickup-drop for all guests attending events here.'
    },
    {
      title: 'Raga Lawns',
      description: 'Located in Koregaon Park Annex, Raga Lawns is a popular venue for formal networking events, leadership summits, and award functions. Our buses support multi-shuttle routes for bulk guest transportation from various corporate offices in Pune.'
    },
    {
      title: 'The Corinthians Resort & Club',
      description: 'Situated in Undri, this premium resort is perfect for corporate offsites, product launches, and team-building events. Our buses ensure safe, comfortable, and scenic group travel from office campuses to this lush destination.'
    },
    {
      title: 'Shivaji Nagar Assembly Hall',
      description: 'A formal venue frequently used for public-private business forums, panel discussions, and training programs. eTravo’s punctual bus service makes mass staff movement from different parts of the city highly convenient.'
    },
    {
      title: 'Suryavanshi Hall, Deccan',
      description: 'Known for cost-effective yet professional settings for internal corporate meets, induction programs, and award ceremonies. Our buses help teams commute collectively while reducing last-minute delays and parking hassles.'
    },
    {
      title: 'Pune International Exhibition & Convention Centre',
      description: 'Located in Moshi, it hosts large-scale trade expos and corporate conventions. Our buses provide direct, scheduled transfers for groups as large as 500 attendees with complete route planning and real-time coordination.'
    },
    {
      title: 'Bal Gandharva Rang Mandir',
      description: 'Used occasionally for cultural corporate functions and seminars, this auditorium in Shivajinagar is accessible and well-connected. eTravo buses provide efficient group transport with focus on comfort and punctuality.'
    },
    {
      title: 'Balgandharva Kaladalan, JM Road',
      description: 'A multipurpose hall used by corporates for presentations and product briefings. Our bus rental ensures group arrivals stay on schedule with clean, air-conditioned rides from any part of Pune.'
    }
  ],

  services: [
    {
      name: 'Corporate Event Bus Hire Pune',
      description: 'Tailored for one-time or multi-day corporate events, our buses ensure large group transportation with ease. Whether it’s transporting employees to a conference or clients to a product launch, our service is trusted by leading companies across Pune.'
    },
    {
      name: 'AC Bus Rental for Business Events Pune',
      description: 'Our air-conditioned buses offer maximum comfort for corporate attendees, executives, and staff. Featuring pushback seats, clean interiors, and experienced drivers, eTravo ensures every journey is stress-free and on time.'
    },
    {
      name: 'Staff Transport Bus for Corporate Functions Pune',
      description: 'From annual meets to townhalls, our staff bus services provide efficient pickup and drop solutions. With options from 25 to 50+ seaters, we tailor routes and timings to match your event requirements.'
    },
    {
      name: 'Luxury Bus on Rent for Corporate Gatherings Pune',
      description: 'Premium buses with high-end interiors, mood lighting, and comfort features—ideal for transporting guests to VIP events or corporate galas with style. Perfect for C-level transfers and media events.'
    },
    {
      name: 'Executive Bus Services for Events Pune',
      description: 'Our executive buses are designed for directors and upper management—featuring silent cabins, Wi-Fi options, charging ports, and fully air-conditioned rides to event venues or meetings.'
    },
    {
      name: 'Affordable Corporate Bus Rental Pune',
      description: 'For cost-sensitive businesses, we offer competitively priced rental plans that include fuel, driver, and GST—ensuring budget-friendly group transport without compromising quality.'
    },
    {
      name: 'Daily Office Commute Bus Pune',
      description: 'Ideal for companies seeking fixed-route, long-term employee transportation. We offer full-month contracts for daily commute buses, including morning pickups and evening drops across Pune’s commercial zones.'
    },
    {
      name: 'Corporate Shuttle Bus Pune',
      description: 'Shuttle services for corporate campuses and multi-office setups with frequent inter-branch connectivity. Our shuttle buses follow tight schedules and provide quick transfers between office locations or client sites.'
    },
    {
      name: 'Bus Rental for Team Outings Pune',
      description: 'From fun day trips to team-building retreats, our buses ensure group enjoyment starts the moment the ride begins. Spacious, clean, and driver-assisted—your team can relax and travel together.'
    },
    {
      name: 'Bus Hire for Client Visits Pune',
      description: 'Expecting high-profile guests or investor groups? Our buses offer polished interiors and professional-grade chauffeurs to ensure your client visits are conducted with grace and hospitality.'
    },
    {
      name: 'Business Conference Bus Rental Pune',
      description: 'Whether your team is attending or organizing a business conference, our scheduled buses take care of group logistics with GPS tracking and dedicated route managers for larger events.'
    },
    {
      name: 'Bus for Employee Transfers Pune',
      description: 'Quick employee movements between branches, factories, or customer locations are possible with our short-duration rental plans. Flexible booking and responsive support are available even for same-day transfers.'
    },
    {
      name: 'Reliable Corporate Bus Pune',
      description: 'eTravo is known for providing dependable, on-time, and incident-free corporate bus services in Pune. Our fleet undergoes regular inspections and each trip is tracked for safety and compliance.'
    },
    {
      name: 'Luxury AC Bus Hire Pune',
      description: 'Perfect for board-level travel or luxury group movement, these buses come with modern suspension, large windows, and personal air vents to ensure a pleasant travel experience.'
    },
    {
      name: 'Staff Pickup and Drop Bus Pune',
      description: 'Reliable daily or event-specific pickup-drop bus service for large teams in manufacturing, IT, and service sectors. Our system ensures zero delays and consistent communication with your admin staff.'
    }
  ],

  tableData: [
    ['Corporate Event Bus Hire Pune', 'AC Bus Rental for Business Events Pune'],
    ['Staff Transport Bus for Corporate Functions Pune', 'Luxury Bus on Rent for Corporate Gatherings Pune'],
    ['Executive Bus Services for Events Pune', 'Affordable Corporate Bus Rental Pune'],
    ['Daily Office Commute Bus Pune', 'Corporate Shuttle Bus Pune'],
    ['Bus Rental for Team Outings Pune', 'Bus Hire for Client Visits Pune'],
    ['Business Conference Bus Rental Pune', 'Bus for Employee Transfers Pune'],
    ['Reliable Corporate Bus Pune', 'Luxury AC Bus Hire Pune'],
    ['Staff Pickup and Drop Bus Pune', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Large-Capacity Buses for Corporate Events",
        "WhyChoosedescription": "eTravo offers 20 to 50-seater buses tailored for transporting large groups of employees, clients, or guests to seminars, off-sites, conferences, and exhibitions in and around Pune."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Fleet",
        "WhyChoosedescription": "Our AC buses feature pushback seats, large windows, reading lights, and ample legroom. Each vehicle is cleaned and serviced regularly, ensuring your teams travel in comfort and style."
    },
    {
        "WhyChooseheading": "Ideal for Group Logistics and Event Transfers",
        "WhyChoosedescription": "From mass pickups across locations to single-point venue drops, eTravo’s corporate bus rentals are ideal for smooth group coordination during events, training programs, or celebrations."
    },
    {
        "WhyChooseheading": "Dedicated Event Support and Route Planning",
        "WhyChoosedescription": "We assign an experienced transport coordinator for large bookings to manage timing, plan pickup routes, and ensure real-time updates to your HR or admin teams."
    },
    {
        "WhyChooseheading": "Flexible Packages for One-Time or Multi-Day Use",
        "WhyChoosedescription": "Our corporate bus rental options include hourly hire, full-day service, and multi-day packages for outstation or multi-day corporate events—designed to suit varying needs and budgets."
    },
    {
        "WhyChooseheading": "Real-Time Tracking and 24/7 Monitoring",
        "WhyChoosedescription": "All buses are GPS-equipped with centralized tracking and route optimization. Admin teams can monitor real-time location and receive alerts for delays or detours."
    },
    {
        "WhyChooseheading": "Hygiene, Safety, and Government Compliance",
        "WhyChoosedescription": "Buses are equipped with fire extinguishers, first aid kits, and sanitized regularly. We follow all government safety and transport compliance norms."
    },
    {
        "WhyChooseheading": "Corporate Billing with GST and Detailed Invoices",
        "WhyChoosedescription": "Enjoy hassle-free monthly billing, complete with GST-compliant invoices and itemized transport costs, simplifying expense reporting and internal audits."
    }
]
}


const faqData = [
    [
        {
            question: 'What types of buses are available for corporate events in Pune?',
            answer: 'eTravo offers AC buses in 20, 32, 40, and 50-seater options, suitable for employee transport, corporate events, and group transfers in Pune.'
        },
        {
            question: 'Can we book buses for one-day or half-day corporate events?',
            answer: 'Yes, our packages include hourly, half-day, full-day, and even multi-day rentals depending on the nature of your event and group size.'
        },
        {
            question: 'Is GPS tracking available for all buses?',
            answer: 'Absolutely. All our corporate buses are GPS-enabled and can be tracked in real-time by your admin or operations team.'
        },
        {
            question: 'Are drivers trained for managing event-based logistics?',
            answer: 'Yes, our drivers are professionally trained, punctual, and well-versed in handling bulk transfers for corporate events and functions.'
        },
        {
            question: 'Does eTravo provide support for pickup and drop coordination?',
            answer: 'Yes, we provide an event coordinator for managing multiple pickup points, timing, and on-ground assistance during large corporate events.'
        },
        {
            question: 'Will the service include GST-compliant billing and official invoicing?',
            answer: 'Yes, we offer GST invoices, monthly billing cycles, and itemized transport breakdowns to meet your corporate compliance needs.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Manish Kulkarni',
        designation: 'Event Coordinator, TechSync Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s bus service for our annual corporate event was seamless. The buses were punctual, clean, and perfectly suited for moving our 150+ attendees.”'
    },
    {
        name: 'Ms. Swati Rane',
        designation: 'Admin Executive, Visionary Labs',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly professional team. We hired their 40-seater AC bus for our team offsite and were impressed with the coordination and driver conduct.”'
    }
];














    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Rental For Corporate Events in Pune",
  "image": "https://www.etravo.in/images/keyword/bus-rental-corporate-events-pune.jpg",
  "description": "Book bus rental for corporate events in Pune with eTravo. Choose AC or luxury buses for business events, staff transportation, daily office commutes, client visits, and team outings. Reliable service, professional drivers, and affordable packages available.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7386"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/bus-rental-corporate-events-pune"
  }
};








    return (
        <div>

<Helmet>
  <title>Bus Rental For Corporate Events in Pune | Staff Transport & Event Shuttle | eTravo</title>
  <meta 
    name="description" 
    content="Hire AC and luxury buses for corporate events, staff transport, client visits, and daily commutes in Pune. eTravo offers affordable and reliable corporate bus rental services." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busrentalforcorporateevents;